// removed by extract-text-webpack-plugin
module.exports = {"root":"wrc8W"};